import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getSocket } from "../../helper/socket";

export const freeSpin = createAsyncThunk(
    "freeSpin/execute",
    async (_, thunkAPI) => {
        const { dispatch, rejectWithValue } = thunkAPI;
        return new Promise((resolve, reject) => {
            const socket = getSocket();
            try {
                socket.emit("freeSpin");

                socket.once("placed_bet", (response) => {
                    if (!response?.status) {
                        reject(rejectWithValue(response?.message || "")); // ✅
                        return;
                    }
                    resolve(response);

                    socket.once("result", (resultData) => {
                        dispatch(updateFreeSpinResult(resultData))
                    })

                    socket.once("final_result", (finalResultData) => {
                        dispatch(updateFreeSpinFinalResult(finalResultData))
                    })
                })
            } catch (error) {
                reject(rejectWithValue(error.message))
            }
        })
    }
)

const freeSpinSlice = createSlice({
    name: "freeSpin",
    initialState: {
        data: null,
        result: null,
        finalResult: null,
        loading: false,
        error: null,
    },
    reducers: {
        resetFreeSpin: () => ({
            data: null,
            result: null,
            finalResult: null,
            loading: false,
            error: null,
        }),
        updateFreeSpinResult: (state, action) => {
            state.result = action.payload;
        },
        updateFreeSpinFinalResult: (state, action) => {
            state.finalResult = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(freeSpin.pending, (state) => {
                state.loading = true;
                state.error = null
            })
            .addCase(freeSpin.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(freeSpin.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
})

export const { resetFreeSpin, updateFreeSpinResult, updateFreeSpinFinalResult } = freeSpinSlice.actions;
export default freeSpinSlice.reducer